import { render } from "./menu.vue?vue&type=template&id=a0011572&scoped=true&ts=true"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"

import "./menu.vue?vue&type=style&index=0&id=a0011572&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0011572"]])

export default __exports__